/* Spanish catalog mirroring locale-bank-misc-fr-part3.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'bank.guided.tabHandling': 'Por procesar · {{count}}',
  'bank.guided.tabDeviation': 'Causa desviación · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} asientos contabilizados causan una desviación',
  'bank.guided.linkHelp': 'Vincula un recibo o una factura a la compra. Si no existe documentación, elige «Sin justificante» para que la elección se guarde y pueda revisarse más adelante.',
  'bank.guided.purchasesMissing': 'A {{count}} compras les faltan justificantes.',
  'bank.guided.noneMissing': 'No falta ningún justificante.',
  'bank.guided.ctl.allHandled': 'Todos los pagos están procesados',
  'bank.guided.ctl.remaining': '{{count}} pendientes',
  'bank.guided.ctl.vouchersLinked': 'Los justificantes necesarios están vinculados',
  'bank.guided.ctl.missingVouchers': '{{count}} justificantes pendientes',
  'bank.guided.ctl.statementBalances': 'Los saldos del extracto bancario coinciden',
  'bank.guided.ctl.deviation': 'Desviación {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'El saldo bancario contabilizado coincide',
  'bank.guided.ctl.clear': 'Listo',
  'bank.guided.finishNote': 'Cuando finalices, Plumme comprueba los saldos, bloquea el periodo y mueve el extracto al archivo.',
  'bank.guided.allChecked': 'Todo está comprobado y listo.',
  'bank.guided.resolveToFinish': 'Resuelve los elementos anteriores para poder finalizar.',
  'bank.guided.toast.noPending': 'No hay sugerencias pendientes de aprobación.',
  'bank.guided.superLinks': 'SuperPlumma vincula',
  'bank.guided.approveSuggestions': 'Aprobar las sugerencias',
  'bank.guided.note.tapPurchase': 'Toca un justificante y después la compra a la que quieres vincularlo.',
  'bank.guided.note.tapSuggestion': 'Toca un justificante y después la sugerencia. Una posible coincidencia aparece resaltada en la lista.',
  'bank.guided.note.dragPurchase': 'Arrastra un justificante a la compra a la que quieres vincularlo.',
  'bank.guided.note.dragSuggestion': 'Arrastra un justificante a una sugerencia. Una posible coincidencia aparece resaltada en la lista.',
  'bank.guided.err.checkImportFirst': 'Revisa primero la transición de la importación.',
  'bank.guided.toast.postingVoided': 'El asiento se ha anulado',
  'bank.guided.archiving': 'Archivando…',
  'bank.guided.archiveNote': 'La revisión se bloquea y se mueve al archivo. Las líneas bancarias ya se contabilizaron cuando se aprobaron.',
  'bank.archive.lockedNote': 'La conciliación está bloqueada. Expande una línea para ver el justificante y el asiento. La cuenta, el IVA y la descripción interna se pueden corregir sin cambiar el importe bancario.',
  'bank.archive.searchPh': 'Buscar asientos',
  'bank.archive.searchHelp': 'Busca por fecha, descripción, importe, cuenta o justificante.',
  'bank.archive.countOf': '{{shown}} de {{total}} asientos',
  'bank.archive.handled': 'Procesado',
  'bank.archive.code': 'Código {{code}}',
  'bank.archive.auditTrail': 'Registro de auditoría',
  'bank.archive.correctionsOne': '{{count}} corrección',
  'bank.archive.correctionsMany': '{{count}} correcciones',
  'bank.archive.noCorrections': 'Sin correcciones',
  'bank.archive.internalDescription': 'Descripción interna',
  'bank.archive.noVoucher': 'Ningún justificante vinculado',
  'bank.archive.noMatch': 'Ningún asiento coincide con la búsqueda o los filtros.',
  'bank.archive.err.correctFailed': 'No se pudo corregir el asiento.',
  'bank.importFix.err.openFirst': 'Abre el vínculo o el asiento antes de corregir la lectura.',
  'bank.importFix.err.reasonLine': 'Indica brevemente por qué se corrige la línea bancaria.',
  'bank.importFix.err.amountNumber': 'El importe debe ser un número.',
  'bank.importFix.removeFromRecon': 'Ignorar línea',
  'bank.importFix.warnTitle': 'Úsalo solo si el PDF/CSV se leyó de forma incorrecta.',
  'bank.importFix.warnBody': 'Esto no modifica el banco ni los justificantes contabilizados. Los valores originales se conservan en el historial.',
  'bank.importFix.blocked': 'La línea ya está vinculada o contabilizada. Abre el vínculo/asiento antes de corregir la lectura en sí.',
  'bank.importFix.originalRead': 'Leído originalmente',
  'bank.importFix.effect': 'Efecto en la conciliación',
  'bank.importFix.deviationNow': 'Desviación ahora:',
  'bank.importFix.afterCorrection': 'Tras la corrección:',
  'bank.importFix.stillDeviates': 'Si la desviación persiste, comprueba si el saldo inicial/final también se leyó de forma incorrecta.',
  'bank.importFix.fixLine': 'Corregir la línea',
  'bank.importFix.removeMisread': 'Ignorar línea',
  'bank.ignoreLine': 'Ignorar línea',
  'bank.ignoreLineHelp': 'Úsalo solo cuando la línea se haya leído mal y no exista en el extracto bancario. La línea permanece en el historial.',
  'bank.ignoreLineConfirm': 'Ignorar la línea',
  'bank.ignoreLineReason': '¿Por qué se ignora la línea?',
  'bank.ignoreLineReasonHint': 'Obligatorio para el registro de auditoría.',
  'bank.ignoreLineReasonPlaceholder': 'Ej.: la línea no existe en el extracto bancario',
  'bank.importFix.removeNote': 'La línea permanece en el historial, pero cuenta como 0,00 kr y se trata como hecha en la conciliación. Úsalo solo cuando la línea no exista en el extracto bancario.',
  'bank.importFix.whyReading': '¿Por qué se corrige la lectura?',
  'bank.importFix.whyReadingPh': 'Ej.: el OCR leyó un importe incorrecto / la línea no existe en el extracto bancario',
  'bank.importFix.err.balancesNumber': 'Los saldos inicial y final deben ser números.',
  'bank.importFix.err.reasonBalance': 'Indica brevemente por qué se corrige el saldo.',
  'bank.importFix.saveBalance': 'Guardar saldo',
  'bank.importFix.balanceWarnTitle': 'Cámbialo solo si el saldo del extracto/de la importación es incorrecto.',
  'bank.importFix.balanceWarnBody': 'El saldo inicial se toma normalmente del saldo final conciliado anterior. El saldo leído originalmente se conserva.',
  'bank.importFix.resultPrefix': 'Con las líneas bancarias procesadas hoy, la diferencia de saldo pasa a ser',
  'bank.importFix.whyBalance': '¿Por qué se corrige el saldo?',
  'bank.importFix.whyBalancePh': 'Ej.: el saldo final se leyó de una fila incorrecta del PDF',
  'bank.loan.intro': 'Úsalo para disposiciones de préstamos, amortizaciones o pagos que se pueden dividir en principal, intereses y comisiones. La cuenta seleccionada se toma del plan de cuentas activo de la empresa y el asiento se contabiliza sin IVA.',
  'bank.loan.account': 'Cuenta de préstamo/deuda',
  'bank.loan.noAccount': 'No se encontró ninguna cuenta de préstamo/deuda habitual en el plan de cuentas activo. Crea la cuenta correcta o usa un asiento libre.',
  'bank.loan.principal': 'Principal / importe del préstamo',
  'bank.loan.splitMismatch': 'La división debe coincidir con el importe bancario. Pendiente: {{amount}} kr.',
  'bank.loan.docLinked': 'La documentación está vinculada.',
  'bank.loan.docRemember': 'Recuerda la documentación.',
  'bank.loan.docHelp': 'Sube el contrato del préstamo, el plan de amortización u otros documentos justificativos. La división debe poder documentarse.',
  'bank.loan.complex': '¿La línea implica a una parte vinculada, una cuenta inusual o un acuerdo de préstamo más complicado?',
  'bank.loan.useFree': 'Usar asiento libre',
  'bank.group.err.sameDirection': 'Todas las líneas bancarias de un grupo de asignación deben tener la misma dirección.',
  'bank.group.err.pickBoth': 'Selecciona las dos líneas bancarias de la transferencia.',
  'bank.group.toast.transferApproved': 'La transferencia se ha aprobado y contabilizado en conjunto.',
  'bank.group.toast.allocationApproved': 'La asignación se ha aprobado y contabilizado en conjunto.',
  'bank.group.err.approveFailed': 'No se pudo aprobar el grupo de conciliación.',
  'bank.group.title': 'Conciliar varios eventos bancarios',
  'bank.group.approve': 'Aprobar y contabilizar grupo',
  'bank.group.oneOperation': 'Una operación controlada',
  'bank.group.oneOperationHelp': 'El grupo reserva todas las líneas bancarias seleccionadas. La contabilización y la vinculación se realizan juntas en el backend cuando apruebas.',
  'bank.group.matchType': 'Tipo de conciliación',
  'bank.group.typeAllocation': 'Asignar el pago a partidas abiertas',
  'bank.group.typeTransfer': 'Transferencia interna entre cuentas propias',
  'bank.group.sourceLine': 'Línea de una cuenta',
  'bank.group.counterLine': 'Contrapartida en la cuenta propia',
  'bank.group.pickOpposite': 'Selecciona la línea bancaria opuesta',
  'bank.group.transferRules': 'Solo se ofrecen las líneas con la misma fecha e importe, signo opuesto y una cuenta bancaria configurada distinta. Las fechas distintas requieren una cuenta puente.',
  'bank.group.noOpenItems': 'No hay {{kind}} abiertas que se puedan asignar.',
  'bank.group.customerInvoices': 'facturas de clientes',
  'bank.group.supplierInvoices': 'facturas de proveedores',
  'bank.group.itemRest': '{{number}} · {{party}} · pendiente {{amount}}',
  'bank.group.removeRow': 'Quitar fila',
  'bank.corr.err.reasonVoid': 'Indica brevemente por qué se anula el asiento.',
  'bank.corr.err.notFieldCorrectable': 'Este tipo de asiento no se puede corregir campo por campo desde la conciliación bancaria. Anula el asiento y contabilízalo correctamente de nuevo, o abre el justificante en el libro diario de justificantes.',
  'bank.corr.err.supplierPaymentVoid': 'Los pagos de facturas de proveedores se anulan desde el justificante del proveedor.',
  'bank.corr.err.noSupportedAction': 'No se encontró una acción compatible para este asiento contabilizado.',
  'bank.receipt.toast.trashed': 'El justificante se ha movido a la papelera.',
  'bank.receipt.err.deleteFailed': 'No se pudo eliminar el justificante.',
  'bank.receipt.deleting': 'Eliminando…',
  'bank.receipt.delete': 'Eliminar justificante',
  'bank.mode.toFull': 'Cambiar a la vista completa',
  'bank.mode.toGuided': 'Cambiar a paso a paso',
  'bank.import.toast.privateSaved': 'Extracto privado guardado: listo para revisar',
  'bank.import.toast.saved': 'Extracto bancario guardado: listo para conciliar',
  'bank.inbox.view.statement': 'Este extracto',
  'bank.inbox.view.unlinked': 'Solo sin vincular',
  'bank.inbox.view.all': 'Todos los justificantes',
  'bank.inbox.showInList': 'Mostrar en la bandeja de entrada',
  'bank.inbox.viewing': 'Mostrando: {{view}} · {{hidden}} ocultos',
  'bank.inbox.waiting': '{{count}} justificantes están pendientes de gestionar',
  'bank.inbox.hide': 'Ocultar bandeja de entrada',
  'bank.inbox.companyAddress': 'la bandeja de justificantes de la empresa',
  'bank.inbox.defaultNote': 'Arrastra un justificante a una línea bancaria o deja que SuperPlumma sugiera coincidencias.',
  'bank.inbox.uploadVoucher': 'Subir justificante',
  'bank.inbox.orDrag': 'O arrastra y suelta en una línea a la que le falte un justificante',
  'bank.inbox.dropHint': 'Suelta aquí los archivos para subir justificantes nuevos.',
  'bank.inbox.noMatch': 'Ningún justificante coincide con la búsqueda.',
  'bank.inbox.noneInSelection': 'No hay justificantes en esta selección · {{hidden}} ocultos por el filtro',
  'bank.inbox.allDone': 'Todos los justificantes se han procesado',
  'bank.inbox.empty': 'La bandeja de entrada está vacía',
  'bank.inbox.tip.showAll': 'Haz clic para mostrar de nuevo todas las líneas bancarias',
  'bank.inbox.tip.showLine': 'Haz clic para mostrar la línea bancaria a la que está vinculado este justificante',
  'bank.inbox.tip.linkedElsewhere': 'Vinculado fuera de este extracto bancario',
  'bank.inbox.linkedHere': 'Vinculado · {{label}}',
  'bank.inbox.linkedIn': 'Vinculado en {{label}}',
  'bank.inbox.previewName': 'Vista previa de {{name}}',
  'bank.inbox.voucherLower': 'justificante',
  'bank.inbox.filteredOne': 'Filtrado por un justificante',
  'bank.inbox.filteredN': 'Filtrado por {{count}} justificantes',
  'bank.inbox.filterShowsLinked': 'Muestra solo las líneas bancarias a las que están vinculados los justificantes',
  'bank.inbox.showAllLines': 'Mostrar todas las líneas',
  'bank.inbox.nBankLines': '{{count}} líneas bancarias',
  'bank.inbox.bankLineLower': 'línea bancaria',
  'bank.inbox.anotherStatement': 'otro extracto bancario',
  'bank.inbox.toast.linkedElsewhere': 'El justificante está vinculado a una línea bancaria en {{label}}.',
  'bank.resolve.annulText': 'El asiento es un duplicado. Revierte el asiento para que no cuente. Si había un justificante, vuelve automáticamente a la bandeja de entrada.',
  'bank.resolve.correctText': 'El asiento debería existir, pero la cuenta, el IVA o la descripción interna son incorrectos. El importe bancario y la fecha permanecen bloqueados.',
  'bank.resolve.err.voidFailed': 'No se pudo anular el asiento contabilizado.',
  'bank.resolve.voiding': 'Anulando…',
  'bank.resolve.confirmVoid': 'Confirmar anulación',
  'bank.resolve.voidReason': 'Motivo de la anulación',
  'bank.resolve.voidReasonHint': 'Obligatorio. El motivo se guarda en el registro de auditoría.',
  'bank.resolve.voidReasonPh': 'Describe brevemente por qué debe anularse el asiento',
  'bank.resolve.row.postedEntry': 'Asiento contabilizado',
  'bank.resolve.row.account': 'Cuenta',
  'bank.resolve.row.vat': 'IVA',
  'bank.resolve.row.amount': 'Importe',
  'bank.resolve.row.lineDate': 'Fecha de la línea bancaria',
  'bank.resolve.row.bankLine': 'Línea bancaria',
  'bank.resolve.row.voucher': 'Justificante',
  'bank.resolve.row.notLinked': 'Sin vincular',
  'bank.resolve.reopenAsDeviation': 'Abrir como desviación',
  'bank.resolve.releaseInvestmentMatch': 'Liberar conciliación bancaria',
  'bank.resolve.reverse': 'Revertir',
  'bank.resolve.alreadyPosted': 'Esta línea bancaria ya está contabilizada o conciliada. Por tanto, no se puede procesar como una línea nueva.',
  'bank.resolve.useCorrection': 'Usa la corrección para la cuenta, el IVA o la descripción interna. El importe bancario, la fecha y el vínculo permanecen bloqueados.',
  'bank.resolve.reverseInfo': 'La reversión anula la compra con un registro de auditoría y deja la línea bancaria abierta para una nueva revisión.',
  'bank.resolve.existingInfo': 'Esto está vinculado a un justificante o asiento existente. Corrige el propio justificante si la base es incorrecta.',
  'bank.resolve.verifiableInfo': 'Este vínculo se puede verificar en los detalles del asiento.',
  'bank.resolve.approving': 'Aprobando…',
  'bank.resolve.approveN': 'Aprobar {{count}} sugerencias',
  'bank.resolve.confirmIntro': 'Revisa el resumen. Las sugerencias conciliadas con un asiento existente no crean asientos nuevos.',
  'bank.resolve.voucherReturns': 'El justificante «{{name}}» vuelve automáticamente a la bandeja de entrada cuando se anula el asiento.',
  'bank.err.uploadVoucherFailed': 'No se pudo subir el justificante.',
  'bank.drop.attachAsDoc': 'Adjuntado como documentación',
  'bank.drop.uploadAnalyzeLink': 'Subido, analizado y vinculado',
  'bank.receipt.confirmDelete': '¿Eliminar el justificante de la bandeja de entrada? Se mueve a la papelera y se puede restaurar.',
  'bank.percentDone': '{{pct}}% completado',
  'mypage.role.owner': 'Propietario',
  'mypage.role.admin': 'Administrador',
  'mypage.role.accountant': 'Contable',
  'mypage.role.viewer': 'Lector',
  'mypage.shortcut.oversikt.title': 'Resumen',
  'mypage.shortcut.oversikt.text': 'Puntuación de salud y resumen financiero del hogar',
  'mypage.shortcut.forbruk.title': 'Gastos',
  'mypage.shortcut.forbruk.text': 'A dónde va el dinero, dividido por categoría',
  'mypage.shortcut.familie.title': 'Familia',
  'mypage.shortcut.familie.text': 'Presupuesto compartido y reparto dentro del hogar',
  'mypage.shortcut.fremtid.title': 'Futuro',
  'mypage.shortcut.fremtid.text': 'Ahorros, préstamos, pensión y planes de futuro',
  'mypage.shortcut.skatt.title': 'Impuestos',
  'mypage.shortcut.skatt.text': 'Declaración de impuestos personal, deducciones y estimación',
  'mypage.fallback.business': 'Empresa',
  'mypage.fallback.signedInUser': 'Usuario con sesión iniciada',
  'mypage.fallback.employerLoadError': 'No se pudieron cargar los empleadores.',
  'mypage.verify.body': 'Algunas funciones, como las invitaciones de clientes y el portal del empleado, requieren que {{email}} esté verificado. Reenvía el enlace si no lo encuentras, abre el enlace del correo y confirma después aquí.',
  'mypage.verify.resend': 'Reenviar verificación',
  'mypage.verify.sending': 'Enviando...',
  'mypage.verify.confirmed': 'Ya lo he verificado',
  'mypage.verify.checking': 'Comprobando...',
  'mypage.err.profileNotConnected': 'El guardado del perfil no está conectado al backend.',
  'mypage.toast.profileUpdated': 'Perfil actualizado',
  'mypage.err.profileUpdateFailed': 'No se pudo actualizar el perfil.',
  'mypage.err.verifyNotConnected': 'La verificación del correo electrónico no está conectada al backend.',
  'mypage.toast.alreadyVerified': 'La dirección de correo electrónico ya está verificada.',
  'mypage.toast.verifyResent': 'El enlace de verificación se ha reenviado.',
  'mypage.err.verifySendFailed': 'No se pudo enviar el enlace de verificación.',
  'mypage.err.verifyStatusFailed': 'No se pudo comprobar el estado del correo electrónico.',
  'mypage.toast.emailVerified': 'La dirección de correo electrónico está verificada.',
  'mypage.toast.stillUnverified': 'La dirección sigue sin estar verificada. Revisa tu bandeja de entrada e inténtalo de nuevo.',
  'mypage.err.personalNotConnected': 'Las finanzas personales no están conectadas al backend en esta versión.',
  'mypage.toast.personalCreated': 'Finanzas personales creadas',
  'mypage.err.personalCreateFailed': 'No se pudieron crear las finanzas personales.',
  'mypage.toast.openPersonalForFamily': 'Abre Finanzas personales para cambiar Familia.',
  'mypage.toast.familyEnabled': 'Familia está activada.',
  'mypage.toast.familyDisabled': 'Familia está desactivada.',
  'mypage.err.familySaveFailed': 'No se pudo guardar el ajuste de Familia.',
  'mypage.titleHelp': 'Mi página es tu cuenta personal en Plumme, separada de las contabilidades. Aquí ves tu perfil, las empresas a las que tienes acceso, los empleadores para los que trabajas y la entrada a tus finanzas personales.',
  'mypage.field.memberSince': 'Miembro desde',
  'mypage.toast.onboardingNotLoaded': 'La puesta en marcha aún no se ha cargado.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Cargando empresas',
  'mypage.biz.loadingText': 'Conectando con el backend de Plumme.',
  'mypage.biz.emptyTitle': 'No tienes empresas propias',
  'mypage.biz.emptyText': 'Puedes crear una empresa aquí más adelante, aunque solo uses Plumme como contable o usuario particular.',
  'mypage.clients.title': 'Asignaciones de clientes',
  'mypage.clients.help': 'Empresas en las que estás invitado como contable, administrador o lector. Los datos de los clientes se mantienen separados de tus propias empresas y de Finanzas personales.',
  'mypage.clients.setup': 'Configuración de contable',
  'mypage.clients.access': 'Acceso de clientes',
  'mypage.clients.empty': 'No tienes asignaciones de clientes activas. Las invitaciones se muestran globalmente tras iniciar sesión.',
  'mypage.pf.creating': 'Creando...',
  'mypage.pf.create': 'Crear finanzas personales',
  'mypage.pf.intro': 'Tu asesor personal para las finanzas del hogar, separado de las contabilidades de las empresas. Elige un resumen para empezar.',
  'mypage.pf.family': 'Familia',
  'mypage.pf.familyText': 'Mostrar la página Familia en Finanzas personales.',
  'mypage.pf.emptyIntro': 'Crea un cliente de finanzas personales para reunir tu resumen privado, la importación, el hogar, los impuestos y los informes sin mezclarlos con tus clientes de contabilidad.',
  'mypage.emp.fallbackRole': 'Empleado',
  'mypage.emp.loadingTitle': 'Cargando empleadores',
  'mypage.emp.emptyTitle': 'Sin empleadores',
  'mypage.emp.loadingText': 'Conectando con el portal del empleado.',
  'mypage.emp.emptyText': 'No hay acceso al portal del empleado registrado para este usuario.',
  'mypage.err.passwordResetNotConnected': 'El restablecimiento de la contraseña no está conectado al backend.',
  'mypage.toast.passwordLinkSent': 'Se ha enviado por correo electrónico un enlace para cambiar tu contraseña',
  'mypage.err.passwordLinkFailed': 'No se pudo enviar el enlace de la contraseña.',
  'mypage.saving': 'Guardando...',
  'mypage.hh.loadError': 'No se pudo cargar el vínculo del hogar.',
  'mypage.hh.updateError': 'No se pudo actualizar el hogar.',
  'mypage.hh.inviteEmailFailed': 'La invitación se creó, pero no se pudo enviar el correo electrónico. Puedes intentarlo de nuevo.',
  'mypage.hh.inviteSent': 'La invitación se creó y se envió.',
  'mypage.hh.left': 'El vínculo del hogar ha finalizado.',
  'mypage.hh.hiddenPending': 'La invitación se retiró y se quitó de la lista.',
  'mypage.hh.hidden': 'La invitación se quitó de la lista.',
  'mypage.hh.loading': 'Cargando el estado del hogar …',
  'mypage.hh.partnerFallback': 'Pareja vinculada',
  'mypage.hh.twoAccounts': 'Dos cuentas separadas · página Familia compartida',
  'mypage.hh.leaveConfirm': '¿Desvincular el hogar? Ambos conservan sus propios datos, mientras que el perfil de Familia compartido finaliza.',
  'mypage.hh.leaving': 'Desvinculando …',
  'mypage.hh.leave': 'Desvincular hogar',
  'mypage.hh.inviteIntro': 'Invita a tu pareja por correo electrónico. El destinatario puede iniciar sesión o crear una cuenta nueva de Plumme, y recibe ayuda para crear Finanzas personales antes de que se apruebe el vínculo.',
  'mypage.hh.inviting': 'Creando …',
  'mypage.hh.invite': 'Invitar a la pareja',
  'mypage.hh.userFallback': 'Usuario de Plumme',
  'mypage.hh.joined': 'El hogar se ha vinculado.',
  'mypage.hh.sentInvites': 'Invitaciones enviadas',
  'mypage.hh.resendFailedToast': 'La invitación está activa, pero no se pudo enviar el correo electrónico.',
  'mypage.hh.resentToast': 'La invitación se ha reenviado.',
  'mypage.hh.resend': 'Reenviar',
  'mypage.hh.remind': 'Recordar',
  'mypage.hh.withdrawn': 'La invitación se ha retirado.',
  'mypage.hh.removeFromList': 'Quitar de la lista',
  'mypage.hh.status.pending': 'Esperando respuesta · {{delivery}}',
  'mypage.hh.status.expired': 'Caducada',
  'mypage.hh.status.declined': 'Rechazada',
  'mypage.hh.status.canceled': 'Retirada',
  'mypage.hh.status.accepted': 'Aceptada',
  'mypage.hh.delivery.delivered': 'correo entregado',
  'mypage.hh.delivery.opened': 'correo abierto',
  'mypage.hh.delivery.clicked': 'enlace abierto',
  'mypage.hh.delivery.failed': 'correo fallido',
  'mypage.hh.delivery.bounced': 'correo rebotado',
  'mypage.hh.delivery.complained': 'marcado como spam',
  'mypage.hh.delivery.delivery_delayed': 'correo retrasado',
  'mypage.hh.delivery.sent': 'correo enviado',
  'audit.domain.settings': 'Ajustes',
  'audit.domain.invoices': 'Facturas',
  'audit.domain.sales': 'Ventas',
  'audit.domain.expenses': 'Compras',
  'audit.domain.customers': 'Clientes',
  'audit.domain.products': 'Productos',
  'audit.domain.suppliers': 'Proveedores',
  'audit.domain.inbox': 'Bandeja de entrada',
  'audit.domain.bank': 'Banco',
  'audit.domain.mileage': 'Registro de kilometraje',
  'audit.domain.payroll': 'Nóminas',
  'audit.domain.business': 'Empresa',
  'audit.domain.access': 'Acceso',
  'audit.summary.rows': '{{count}} filas',
  'audit.summary.fields': '{{count}} campos',
  'audit.event.updated': 'Actualizó {{domains}}',
  'audit.event.updatedBusinessData': 'Actualizó los datos de la empresa',
  'audit.event.businessCreated': 'Creó la empresa',
  'audit.event.inviteCreated': 'Invitó a {{email}} como {{role}}',
  'audit.event.inviteAccepted': '{{user}} aceptó la invitación',
  'audit.event.deletionRequestedFor': 'Solicitó la eliminación de la empresa el {{date}}',
  'audit.event.deletionRequested': 'Solicitó la eliminación de la empresa',
  'audit.event.deletionCanceled': 'Canceló la eliminación de la empresa',
  'audit.fallback.newUser': 'usuario nuevo',
  'audit.fallback.userLower': 'usuario',
  'audit.fallback.user': 'Usuario',
  'audit.fallback.unknownUser': 'Usuario desconocido',
  'audit.err.loadFailed': 'No se pudo cargar el registro de actividad.',
  'audit.meta.time': 'Hora',
  'audit.meta.user': 'Usuario',
  'audit.meta.role': 'Rol',
  'audit.meta.action': 'Acción',
  'audit.meta.source': 'Origen',
  'audit.meta.invite': 'Invitación',
  'audit.meta.targetUser': 'Usuario destinatario',
  'audit.detail.before': 'Antes:',
  'audit.detail.after': 'Después:',
  'audit.titleHelp': 'El registro de actividad es una pista de auditoría: muestra cada acción importante realizada en la contabilidad: quién hizo qué, cuándo y en qué área. Es útil para la trazabilidad y el control cuando colaboran varias personas.',
  'audit.search': 'Buscar en el registro de actividad de {{year}}',
  'audit.scope.all': 'Todos',
  'audit.scope.others': 'Otros',
  'audit.scope.mine': 'Yo',
  'audit.scope.access': 'Acceso',
  'audit.col.event': 'Evento',
  'audit.empty.loadingTitle': 'Cargando el registro de actividad',
  'audit.empty.loadingText': 'Conectando con el backend de Plumme.',
  'audit.empty.noMatchTitle': 'Sin coincidencias',
  'audit.empty.noMatchText': 'Ninguna actividad coincide con el filtro. Prueba a restablecerlo.'
});
